document.addEventListener('DOMContentLoaded', () => {
    const hulkModalTriggers = Array.from(document.querySelectorAll('.btn-modal-hulk'));
    if (hulkModalTriggers.length) {
        hulkModalTriggers.forEach(($trigger) => {
            $trigger.addEventListener('click', (e) => {
                e.preventDefault();

                const targetId = $trigger.dataset.targetId;
                const $hulkModal = document.querySelector('.modal-hulk[data-id='+targetId+']');
                if ($hulkModal) {
                    $hulkModal.classList.add('visible');
                } else {
                    console.warn('Hulk modal not found');
                }
            });
        });
    }

    const hulkModals = Array.from(document.querySelectorAll('.modal-hulk'));
    if (hulkModals.length) {
        hulkModals.forEach(($modal) => {
            const $modalOverlay = $modal.querySelector('.modal-hulk__overlay');
            $modalOverlay.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();

                $modalOverlay.closest('.modal-hulk').classList.remove('visible');
            });

            const $modalClose = $modal.querySelector('.modal-hulk__close');
            $modalClose.addEventListener('click', (e) => {
                e.preventDefault();

                $modalClose.closest('.modal-hulk').classList.remove('visible');
            });
        })
    }
});